"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionDetails = exports.Draft = exports.Details = exports.CourseEnrollmentsPage = exports.CourseEnrollment = exports.CourseDetails = void 0;
var CourseDetails_1 = require("./CourseDetails");
Object.defineProperty(exports, "CourseDetails", { enumerable: true, get: function () { return __importDefault(CourseDetails_1).default; } });
var CourseEnrollment_1 = require("./CourseEnrollment");
Object.defineProperty(exports, "CourseEnrollment", { enumerable: true, get: function () { return __importDefault(CourseEnrollment_1).default; } });
var CourseEnrollmentsPage_1 = require("./CourseEnrollmentsPage");
Object.defineProperty(exports, "CourseEnrollmentsPage", { enumerable: true, get: function () { return __importDefault(CourseEnrollmentsPage_1).default; } });
var Details_1 = require("./Details");
Object.defineProperty(exports, "Details", { enumerable: true, get: function () { return __importDefault(Details_1).default; } });
var Draft_1 = require("./Draft");
Object.defineProperty(exports, "Draft", { enumerable: true, get: function () { return __importDefault(Draft_1).default; } });
var SectionDetails_1 = require("./SectionDetails");
Object.defineProperty(exports, "SectionDetails", { enumerable: true, get: function () { return __importDefault(SectionDetails_1).default; } });
//# sourceMappingURL=index.js.map